import React from 'react'
import { Box, Button, Paper, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { LockOutlined } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'
import { ROUTES } from '~/views/routes'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(6),
    textAlign: 'center',
    maxWidth: 420
  },
  icon: {
    fontSize: '4rem',
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(2)
  }
}))

export const UnauthorizedPage = () => {
  const classes = useStyles()
  const history = useHistory()

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper}>
        <LockOutlined className={classes.icon} />
        <Typography variant='h5' gutterBottom>
          Acceso no autorizado
        </Typography>
        <Typography color='textSecondary' style={{ marginBottom: 24 }}>
          No tenés permiso para ver esta página.
        </Typography>
        <Button
          variant='contained'
          color='primary'
          onClick={() => history.push(ROUTES.ADMIN.DASHBOARD.INDEX)}>
          Volver al inicio
        </Button>
      </Paper>
    </Box>
  )
}

export default UnauthorizedPage
